import React, { useContext, useEffect, useState } from 'react';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Grid } from 'react-loader-spinner';
import Instruction from '../../Documentation/Instruction';
import Input2 from '../../NecttosComp/Input/Input2';
import { getDepartments } from '../../NecttosComp/APICaller/ApiServices';
import { useQuery } from 'react-query';

interface InvoiceManagementProps {
	onClose: () => void;
}

function SubjectAllocationAuto({ onClose }: InvoiceManagementProps) {
	const { collegeId } = useContext(FirebaseContext);
	const [loading, setLoading] = useState(false);
	const [filters, setFilters] = useState<any>({ academicYear: '' });
	const { data: departments } = useQuery(['getDepartments', collegeId], getDepartments(collegeId));
	const [academicYears, setAcademicYears] = useState<any>([]);

	const fetchAutoIndex = async () => {
		setLoading(true);
		const instance = await getAxiosTokenInstance();
		try {
			const resp = await instance.post('/college/fyugp/subjectAllocation', {
				collegeId,
			});

			if (resp.data.statusCode === 400) {
				throw new Error(resp.data.message || 'API Error');
			} else if (resp?.data?.list?.length > 0) {
				// Handle the case where the list is populated
			} else {
				// Handle the case where the list is empty
			}
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	const calcAcademicYears = () => {
		const today = new Date();
		const currentYear = today.getFullYear();
		const currentMonth = today.getMonth() + 1;

		const startYear = currentMonth >= 8 ? currentYear : currentYear - 1;

		let academicYears = [];
		for (let year = startYear - 7; year <= startYear + 1; year++) {
			const nextYear = (year + 1) % 100;
			academicYears.push(`${year}-${nextYear < 10 ? '0' + nextYear : nextYear}`);
		}

		academicYears = academicYears.reverse();
		setAcademicYears(academicYears);
	};

	useEffect(() => {
		calcAcademicYears();
	}, []);

	return (
		<>
			<Main title=' FYUGP Course Schedule' width='100%' height='100%'>
				<Header>
					<div className='flex'></div>
					<div className='flex'>
						<Instruction keyId={'courseSchedule'} />
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body>
					{loading ? (
						<div className='m-5 p-5 flex justify-center items-center'>
							<Grid height={'250'} width='250' color='#0083f5' visible={loading} />
						</div>
					) : (
						<>
							<div className='flex w-auto'>
								<Input2 width='12vw' fieldName='Filter Department' returnKey='departmentId' optionDisplay='name' didntShowKey optionKey='_id' state={filters} setState={setFilters} options={departments} type='drop' className='w-[15vw]' />
								<Input2 width='12vw' fieldName='Filter by Semester' returnKey='semester' state={filters} setState={setFilters} options={['Semester 1', 'Semester 2', 'Semester 3', 'Semester 4', 'Semester 5', 'Semester 6', 'Semester 7', 'Semester 8']} type='drop' className='w-[13vw]' />
								<Input2 width='12vw' fieldName='SelectTypes' returnKey='types' state={filters} setState={setFilters} options={['AEC', 'AEC_OL', 'DSC_A', 'MDC', 'VAC', 'DSC_B', 'DSC_C', 'OpenCourse']} type='mdrop' className='w-[13vw]' />
								<Input2 width='12vw' fieldName='Filter by Acdemic Year' returnKey='academicYear' state={filters} setState={setFilters} options={academicYears} type='drop' className='w-[15vw]' />
							</div>
							<Button type='close' onClick={fetchAutoIndex}>
								Post Course Allocation
							</Button>
						</>
					)}
				</Body>
			</Main>
		</>
	);
}

export default SubjectAllocationAuto;
